import { httpClient } from "@/app/old/desktop/shared/services/";
import { BaseService } from "@/app/old/desktop/shared/services/";
const URL = "fields";

class API extends BaseService {
  constructor() {
    super(null, URL);
  }
}

export const customFieldsService = new API();
